import React from "react";
import Form from "react-bootstrap/lib/Form";

export const InputDate = ({
  fieldId,
  fieldName,
  isActive,
  values,
  isRequired,
  errors,
  handleChange,
}) => (
  <Form.Group>
    <div className="field field--input">
      <Form.Label htmlFor={`birthDate`} className="field__label">
        {isRequired ? `${fieldName}*` : fieldName}
      </Form.Label>
      <Form.Control
        type="date"
        max="2070-12-31"
        disabled={!isActive}
        id={fieldId}
        name={fieldId}
        value={values.birthDate}
        onChange={handleChange}
        className="field__input"
        placeholder={fieldName}
        title=""
        isInvalid={!!errors[fieldId]}
        autocomplete="off"
      />
    </div>
    <Form.Control.Feedback type="invalid" className="field--invalid d-flex">
      {errors[fieldId]}
    </Form.Control.Feedback>
  </Form.Group>
);
